import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import React from 'react';
import AppThemeProvider from './themes/AppThemeProvider';
import App from './App';
import { persistor, store } from '@core/configureStore/store';
import { PersistGate } from 'redux-persist/integration/react';

import './assets/styles/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </PersistGate>
  </Provider>,
);
